import { HtmlTemplates } from 'utils/html-templates';

export default props => class modal {

    constructor() {
        this.settings = {
            title: '',
            content: '',
            type: '',
            id: '',
            buttons: [],
            showFooter: true,
            onClose: null,
            scrollableContendNode: '.modal__content',
            ...props
        };

        this.domNode = document.body;

        this.id = (this.settings.id && this.settings.id !== '' && document.querySelector(`#${this.settings.id}`) === null) ? this.settings.id : `modal-component-id-${new Date().getTime()}`;

        if(!this.settings.type || this.settings.type === '') {
            this.settings.type = "modal";
        }

        //append modal in domNode
        this.domNode.insertAdjacentHTML('beforeend', HtmlTemplates.modal({
            title: this.settings.title ,
            content: this.settings.content ,
            type: this.settings.type ,
            id: this.id,
            buttons: this.settings.buttons,
            showFooter: this.settings.showFooter
        }));

        this.modal =  document.querySelector(`#${this.id}`);

        if(this.modal === null ) {
            this.notify('modal::errorOnInit' , this);
            return;
        }

        this.modalScrollableTarget = this.settings.scrollableContendNode ? this.modal.querySelector(this.settings.scrollableContendNode) : null;

        this.modalCloseBtn = this.modal.querySelector('.modal__header--closeButton');

        this.modalFooterBtns = this.settings.buttons;

        this.setListeners();

        this.notify(`modal::ready`, this );
    }

    notify( eventName , paramsToNotify = { }) {

        const event = new CustomEvent( eventName , { detail: paramsToNotify } );
        document.dispatchEvent(event);
        console.log(eventName);

    }

    watch( eventName , callback = { }) {
        document.addEventListener(eventName, callback.bind(this));
    }

    close(e) {
        let closeModal = false,
            allModals;

        if(e && e.type === 'keydown' && (e.key === 'Escape' || e.keyCode === 27) ) {
            //chiudo se: 1) modal Ã¨ aperto , 2) non ci sono altri modals aperti successivi a questo ( z-index non lo gestisco )

            let allModals = document.querySelectorAll('[data-component-name="modal"].modal--opened');

            if(allModals[allModals.length -1] === this.modal) {
                closeModal = true;
            }
        }
        else if(e && e.type === 'click' && e.currentTarget === this.modalCloseBtn) {
            //al click su btnClose chiudo sempre

            closeModal = true;
        }
        else if(e === undefined) {
            //casistica close da metodi onClick dei modalFooterBtns o altro trigger manuale non gestito

            closeModal = true;
        }

        if(closeModal) {
            this.modal.classList.remove('modal--opened');

            if ( Ps !== undefined && this.modalScrollableTarget ) {
                Ps.destroy(this.modalScrollableTarget);
            }

            if(typeof this.settings.onClose === "function") {
                this.settings.onClose();
            }

            this.notify('modal::closed' , this);
            this.destroy();

        }
    }

    setListeners() {
        //#1 listen on keypress ESC / ESCAPE for to close
        this.close = this.close.bind(this);
        if(this.modalCloseBtn !== null) {
            document.addEventListener('keydown', this.close);
        }

        //#2 listen on modal closeBtn
        if(this.modalCloseBtn !== null) {
            this.modalCloseBtn.addEventListener('click', this.close);
        }

        //#3 listen on click extra buttons
        if(this.modalFooterBtns && this.modalFooterBtns.length) {
            for(let [index, button] of this.modalFooterBtns.entries()) {
                if(typeof this.modalFooterBtns[index].onClick === "function") {
                    this.modalFooterBtns[index].onClick = this.modalFooterBtns[index].onClick.bind(this);
                    this.modal.querySelectorAll('.modal__footer button')[index].addEventListener('click', this.modalFooterBtns[index].onClick);
                }
            }
        }
    }

    destroy() {
        //#1 rimuovo listener su closeBtn
        if(this.modalCloseBtn !== null) {
            this.modalCloseBtn.removeEventListener('click', this.close);
        }

        //#2 rimuovo listener kepress ESCAPE
        if(this.modalCloseBtn !== null) {
            document.removeEventListener('keydown', this.close);
        }

        //#3 rimuovo listener su extra footerBtns
        if(this.modalFooterBtns && this.modalFooterBtns.length) {
            for(let [index, button] of this.modalFooterBtns.entries()) {
                if(typeof this.modalFooterBtns[index].onClick === "function") {
                    this.modal.querySelectorAll('.modal__footer button')[index].removeEventListener('click' , this.modalFooterBtns[index].onClick);
                }
            }
        }

        this.modal.remove();
        this.notify('modal::destroyed' , this);
    }

    open() {

        if(this.modal === null ) return;

        this.modal.classList.add('modal--opened');

        document.activeElement.blur();

        if ( Ps !== undefined && this.modalScrollableTarget) {
            Ps.initialize(this.modalScrollableTarget);
        }

        this.notify(`modal::opened`, this );
    }
}


// WEBPACK FOOTER //
// ./cpanel/js/components/modals/modules/modal.js